import React from 'react';
import Layout from '../../reusables/layout/layout';
import Login from '../../Component/loginform/login';


const PaymentLoginPublic = () => {


  return (
    <div >
      <Layout>
        <Login examType={"PUBLIC SERVICE EXAMINATION"} url={'/individual/login/02'} navigateTo={'/requisition/public'} homeLink={"https://publicservice.examsboard.lagosstate.gov.ng/"} />
      </Layout>
    </div>
  );
};

export default PaymentLoginPublic;